import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import styled from '@emotion/styled'
import CustomButton from '../../leastcomponent/custombutton/custombutton'
import { updatePushToPanding } from '../../hooks/jobcardHooks'
// import "./../../src/style/modal.css";
// import '../assets/css/modal.css'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 350,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  p: 2
}

const BoxWrapper = styled(Box)(() => ({
  '.button-box': {
    width: '150px'
  }
}))
// interface propI {
//   open: boolean;
//   handleClose: () => void;
//   handleOpen?: () => void;
//   handleDelete: (id?: string | undefined) => void;
//   id?: string;
//   isDeleteOrRestoreAll?: boolean;
// }

const PushToPendingModal = (props) => {
  const {
    open,
    handleClose,
    id,
    jcNum,
    isGoBackDashboard
  } = props
  const { mutate: updatePushToPndiing, isLoading: isSubmitting } = updatePushToPanding(true, !!isGoBackDashboard)
  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby=""
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <BoxWrapper>
            <Box textAlign={'center'}>
              <Box m={2}>
                <Typography>
                Are you sure you want to push the Job Card {jcNum} to the pending list?
                </Typography>
              </Box>

              <Box m={2} display={'flex'} justifyContent={'space-between'}>
                <CustomButton
                  variant="outlined"
                  className="button-box"
                  onClick={() => handleClose()}
                  title="Cancel"
                />
                <CustomButton
                  variant="outlined"
                  className="button-box blue-bg ml-20"
                  title="Yes"
                  loading={isSubmitting}
                  onClick={() => {
                    updatePushToPndiing({ id })
                  }}
                />
              </Box>
            </Box>
          </BoxWrapper>
        </Box>
      </Modal>
    </div>
  )
}
export default PushToPendingModal
